import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const FeedbackReportsMain = (props) => {
  const { isMobile, mobileMode } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import('../MobileComponents/FeedbackReportsMob');
        setComponent(() => module.default);
      } else {
        const module = await import('../WebComponents/FeedbackReportsWeb');
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
 return component ? (
  <LoadedComponent {...props} mode={mobileMode} />
  ) : (
   <></>
  );
};

export default FeedbackReportsMain;
